// Key constants
export const KEY_ENTER = 'Enter';
export const KEY_ESCAPE = 'Escape';
export const KEY_ARROW_UP = 'ArrowUp';
export const KEY_ARROW_DOWN = 'ArrowDown';

// Hotkey combinations
export const HOTKEY_SAVE: { key: string; ctrl: boolean } = { key: 's', ctrl: true };
export const HOTKEY_SAVE_NEW: { key: string; ctrl: boolean; shift: boolean } = { key: 's', ctrl: true, shift: true };
export const HOTKEY_CANCEL: { key: string } = { key: KEY_ESCAPE };
